<template>
    <div>
        <div id="genericLoginPage" class="container-fluid override">

            <div class="row">
                <div class="col-sm-12" style="margin-top: 5em;">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-2"></div>
                <div class="col-sm-8" style="text-align:center;">
                    <span style="padding-right:0.5em;color: #FFF">Password</span>
                    <input ref="password" type="text" name="tempPassword" value="" />
                    <button style="margin-left: 0.5em;" @click="login">Login</button>
                </div>
                <div class="col-sm-2"></div>
            </div>

        </div>
    </div>
</template>

<script>
    const settings = require('/ps_settings/config.json');
    export default {
        name: 'GenericLogin',
        components: {
        },
        data() {
            return {
                envVars: process.env,
                store: this.$store
            };
        },
        beforeCreate() {
        },
        methods: {
          login(e) {
              console.log('e');
              console.log(e);
              this.$cookies.set('genericLogin', 
                                this.$refs.password.value, 
                                settings.GENERIC_AUTH_EXPIRATION,
                                null,
                                null,
                                true,
                                'None');
              window.location.href = '/'
          }
        },
        mounted: function() {
            this.$refs.password.focus();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1 {
        font-family: Montserrat, sans-serif;
        font-size: 24pt;
        font-weight: bold;
    }

    .loginForm {
        color: #000;
        border: 1px solid gray;
        padding: 1em 5em 10em 5em;
    }
    .override {
        position: absolute;
        z-index: 19999;
        background-color: white;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>
